import * as React from "react";

// True when rendered inside our Field (Base UI Field.Root). Field parts and
// controls use this to decide between the Base UI primitive (auto id/aria
// wiring) and a plain element, since Base UI Field parts throw outside Root.
export const FieldRootContext = React.createContext(false);
